import { createApi } from '@reduxjs/toolkit/query/react'
import { createAdminBaseQuery } from '../../../Utils/baseQuery'

export const adminApiService = createApi({
  reducerPath: 'adminApi',
  baseQuery: createAdminBaseQuery('/admin/'),
  endpoints: (builder) => ({
    getAdminProfile: builder.query({
      query: () => 'profile',
      keepUnusedDataFor: 0
    }),
    getAdmins: builder.query({
      query: () => 'list',
      keepUnusedDataFor: 0
    }),
    createAdmin: builder.mutation({
      query: (payload) => ({
        url: 'create',
        method: 'POST',
        body: payload
      })
    }),
    updateAdmin: builder.mutation({
      query: ({ id, payload }) => ({
        url: `update/${id}`,
        method: 'PUT',
        body: payload
      })
    }),
    changePassword: builder.mutation({
      query: (payload) => ({
        url: 'change-password',
        method: 'POST',
        body: payload
      })
    }),
    deactivateAdmin: builder.mutation({
      query: (id) => ({
        url: `deactivate/${id}`,
        method: 'PATCH'
      })
    }),

    // Send a one-time magic login link to a resident or vendor by their user ID.
    // The backend emails the link directly — the admin never sees the code itself.
    // Contract: POST /admin/send-login-link/:userId → { success: true, message }
    sendLoginLink: builder.mutation({
      query: (userId) => ({
        url: `send-login-link/${userId}`,
        method: 'POST',
      })
    })
  })
})

export const {
  useGetAdminProfileQuery,
  useLazyGetAdminProfileQuery,
  useGetAdminsQuery,
  useLazyGetAdminsQuery,
  useCreateAdminMutation,
  useUpdateAdminMutation,
  useChangePasswordMutation,
  useDeactivateAdminMutation,
  useSendLoginLinkMutation,
} = adminApiService
